const clientSideCSVDownload = (csv: string, filename: string) => {
	const BOM = "\uFEFF";
	const csvFile = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
	const downloadLink = document.createElement("a");
	downloadLink["download"] = filename;
	downloadLink["href"] = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = "none";

	document.body.appendChild(downloadLink);
	downloadLink.click();
	document.body.removeChild(downloadLink);
};

export default clientSideCSVDownload;
